import { useState, useCallback } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Header from './components/Header'
import SiteMap from './components/SiteMap'
import TimelineScrubber from './components/TimelineScrubber'
import DetailPanel from './components/DetailPanel'
import WelcomeBanner from './components/WelcomeBanner'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  const [siteCount, setSiteCount] = useState(0)
  const handleSiteCountChange = useCallback((count: number) => {
    setSiteCount(count)
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Header siteCount={siteCount} />
      <main id="main">
        <WelcomeBanner />
        <div id="map-wrapper">
          <SiteMap onSiteCountChange={handleSiteCountChange} />
        </div>
        <TimelineScrubber />
        <DetailPanel />
      </main>
    </QueryClientProvider>
  )
}
